import axios from '../../axios';
import { getURL } from 'src/utils/config';
import { handleResponse } from 'src/utils/responseHandler';

const getModels = (callback) => {
    axios({
        method: 'get',
        url: getURL('/api/v1/models'),
        validateStatus: (status) => handleResponse(status)
    }).then((response) => callback(response));
};

export { getModels };
